/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface SkillMapCellPayload {
    cmId: string;
    fieldId: string;
    fieldLevel: string;
}

export interface SkillMapCellResponse {
    cellData: SkillMapCellItem[];
}

export interface SkillMapCellItem {
    fieldName1: string;
    fieldId1: string;
    fieldName2: string;
    fieldId2: string;
    fieldName3: string;
    fieldId3: string;
    levelTitle: string;
    contents: string;
    careerCount: string;
    status: string;
    statusId: string;
    cellSubCareer: CellSubCareerItem[];
    cmcId: string;
}

export interface CellSubCareerItem {
    careerType: string;
    careerTypeId: string;
    careerTitle: string;
    careerId: string;
    rankName: string;
    rankId: string;
    isPriority: string;
    status: string;
    statusId: string;
    statusNum: string;
    complDate: string;
    validDate: string;
    aplType: string;
    appChangeOkFlg: boolean;
    appCancelOkFlg: boolean;
    appLectureOkFlg: boolean;
    appResultOkFlg: boolean;
    assessMentResultDispFlg: boolean;
    certificateUploadFlg: boolean;
    certificateDispFlg: boolean;
    lecCancelOkFlg: boolean;
    referenceOkFlg: boolean;
    retakeOkFlg: boolean;
    taskReportOkFlg: boolean;
    enqueteDispFlg: boolean;
    compulsoryCssClass: string;
    classId: string;
    outOfPeriodFlg: boolean;
    reasonCode: string;
    seq: string;
    testFlg: boolean;
    careerImageUrl?: string;
}

class SkillMapCellService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "skillMapCell");
    }

    public async skillMapCell(payload: SkillMapCellPayload, resolved: (response: SkillMapCellResponse) => void, rejected: (error: any) => void) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as SkillMapCellResponse;
                resolved(response);
            },
            rejected
        );
    }

    public async postResponse(payload: SkillMapCellPayload): Promise<SkillMapCellResponse> {
        return super.postWithPromise(payload).then((json: any) => {
            const response = json as SkillMapCellResponse;
            return response;
        });
    }
}

export default SkillMapCellService;
